var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNormalModeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66675C5.40841 1.66675 1.66675 5.40841 1.66675 10.0001C1.66675 14.5917 5.40841 18.3334 10.0001 18.3334C14.5917 18.3334 18.3334 14.5917 18.3334 10.0001C18.3334 5.40841 14.5917 1.66675 10.0001 1.66675ZM10.0001 17.0834C6.09175 17.0834 2.91675 13.9084 2.91675 10.0001C2.91675 6.09175 6.09175 2.91675 10.0001 2.91675C13.9084 2.91675 17.0834 6.09175 17.0834 10.0001C17.0834 13.9084 13.9084 17.0834 10.0001 17.0834Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 10.4751L11.6832 11.2584L11.6666 11.2668L11.2249 10.6168L8.31657 6.3501H7.1499V13.6501H8.34157V9.34176L8.33324 8.5501L8.35824 8.54176L8.79157 9.2001L11.9082 13.6501H12.8499V6.3501H11.6666V10.4751Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNormalModeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Normal_Mode_Icon.ac0c4219bd91dd052c2edb42f33a143f.svg";